import { SubChannelConfig, MixedSubChannelConfig } from './../models/subchannel';
import { HttpResult } from './../models/API';
import { NavConfig } from 'src/models/configs/navConfig';
export const httpInject = (url: string): boolean | HttpResult => {
    // tslint:disable
    if (!~url.indexOf('v3.sohu.com')) {
        return false;
    } else {
        if (~url.indexOf('subchannel/config')) {
            const data: Array<SubChannelConfig | MixedSubChannelConfig> = [
                {
                    "type": "MixedChannel",
                    "name": "体育",
                    "regionId": 5138,
                    "display": ["focusImage", "text", "text", "text"],
                    "link": "//sports.sohu.com",
                    "spm": "column-sports",
                    "children": [
                        {
                            'type': 'channel',
                            'name': 'NBA',
                            'regionId': 4358,
                            'display': ["text", "text"],
                            "link": "//sports.sohu.com/s/nba",
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': 'CBA',
                            'regionId': 4357,
                            'display': ["text", "text"],
                            "link": "//sports.sohu.com/s/cba",
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': '国足',
                            'regionId': 4283,
                            'display': ["text", "text"],
                            "link": "//sports.sohu.com/s/cnmenfootball",
                            "spm": "",
                        }]
                },
                {
                    "type": "MixedChannel",
                    "name": "财经",
                    "regionId": 82,
                    "display": ["focusImage", "text", "text", "text"],
                    "link": "//business.sohu.com",
                    "spm": "column-business",
                    "children": [
                        {
                            'type': 'channel',
                            'name': '宏观',
                            'regionId': 6732,
                            'display': ["text", "text"],
                            "link": "//business.sohu.com/category/macrography",
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': '股票',
                            'regionId': 4954,
                            'display': ["text", "text"],
                            "link": "//q.stock.sohu.com/",
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': '理财',
                            'regionId': 6733,
                            'display': ["text", "text"],
                            "link": "//business.sohu.com/998",
                            "spm": "",
                        }]
                },
                {
                    "type": "MixedChannel",
                    "name": "娱乐",
                    "regionId": 117,
                    "display": ["focusImage", "text", "text", "text"],
                    "link": "//yule.sohu.com",
                    "spm": "column-yule",
                    "children": [
                        {
                            'type': 'channel',
                            'name': '明星',
                            'regionId': 8717,
                            'display': ["text", "text"],
                            'link': '//yule.sohu.com/1406',
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': '影视',
                            'regionId': 8716,
                            'display': ["text", "text"],
                            "link": "//yule.sohu.com/1408",
                            "spm": "",
                        },
                        {
                            'type': 'channel',
                            'name': '综艺',
                            'regionId': 8714,
                            'display': ["text", "text"],
                            "link": "//yule.sohu.com/1410",
                            "spm": "",
                        }]
                }, {
                    "type": "channel",
                    "name": "汽车",
                    "regionId": "8833",
                    "display": ["image", "text", "text", "text", "text"],
                    "link": "//auto.sohu.com",
                    "spm": "column-auto",
                }, {
                    "type": "channel",
                    "name": "军事",
                    "regionId": "91",
                    "display": ["image", "text", "text", "text", "text"],
                    "link": "//mil.sohu.com",
                    "spm": "column-mil",
                }, {
                    "type": "channel",
                    "name": "科技",
                    "regionId": "8834",
                    "display": ["image", "text", "text", "text", "text"],
                    "link": "//it.sohu.com",
                    "spm": "column-it",
                }, {
                    "type": "channel",
                    "name": "健康",
                    "regionId": "8856",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-health",
                }, {
                    "type": "channel",
                    "name": "养生",
                    "regionId": "8860",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-medlar",
                }, {
                    "type": "channel",
                    "name": "健身",
                    "regionId": "8853",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-fit",
                }, {
                    "type": "channel",
                    "name": "NBA观点",
                    "regionId": "8838",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-work",
                }, {
                    "type": "channel",
                    "name": "职场",
                    "regionId": "8851",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-work",
                }, {
                    "type": "channel",
                    "name": "教育",
                    "regionId": "8852",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-learning",
                }, {
                    "type": "channel",
                    "name": "科学",
                    "regionId": "8845",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-science",
                }, {
                    "type": "channel",
                    "name": "旅游",
                    "regionId": "8832",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-travel",
                }, {
                    "type": "channel",
                    "name": "摄影",
                    "regionId": "8837",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-photography",
                }, {
                    "type": "channel",
                    "name": "历史",
                    "regionId": "8847",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-history",
                }, {
                    "type": "channel",
                    "name": "文化",
                    "regionId": "8857",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-cul",
                }, {
                    "type": "channel",
                    "name": "星座",
                    "regionId": "8835",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-astro",
                }, {
                    "type": "channel",
                    "name": "育儿",
                    "regionId": "8846",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-baby",
                }, {
                    "type": "channel",
                    "name": "时尚",
                    "regionId": "8854",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-fashion",
                }, {
                    "type": "channel",
                    "name": "美妆",
                    "regionId": "8849",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-makeup",
                }, {
                    "type": "channel",
                    "name": "游戏",
                    "regionId": "8836",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-game",
                }, {
                    "type": "channel",
                    "name": "生活技巧",
                    "regionId": "8858",
                    "display": ["image", "text", "text"],
                    'link': '',
                    "spm": "column-skills",
                }, {
                    "type": "channel",
                    "name": "电影",
                    "regionId": "8844",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-movie",
                }, {
                    "type": "channel",
                    "name": "美食",
                    "regionId": "8855",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-food",
                }, {
                    "type": "channel",
                    "name": "萌宠",
                    "regionId": "8848",
                    "display": ["image", "image", "image"],
                    'link': '',
                    "spm": "column-pets",
                }, {
                    "type": "channel",
                    "name": "百科",
                    "regionId": "8850",
                    "display": ["image", "text", "text", "text", "text"],
                    'link': '',
                    "spm": "column-encyclopedia",
                }];
            return {
                'status': 200,
                'body': { data },
            }
        } else if (~url.indexOf('navs/config')) {
            const data: NavConfig[] = [{
                name: '新闻',
                link: 'http://news.sohu.com',
            }, {
                name: '军事',
                link: 'http://mil.sohu.com',
            }, {
                name: '专题',
                link: 'http://www.sohu.com/subject',
            }, {
                name: '财经',
                link: 'http://business.sohu.com',
            }, {
                name: '宏观',
                link: 'http://business.sohu.com/category/macrography',
            }, {
                name: '理财',
                link: 'http://business.sohu.com/998',
            }, {
                name: '体育',
                link: 'http://sports.sohu.com',
            }, {
                name: 'NBA',
                link: 'http://sports.sohu.com/s/nba',
            }, {
                name: 'CBA',
                link: 'http://sports.sohu.com/s/cba',
            }, {
                name: '房产',
                link: 'http://www.focus.cn',
            }, {
                name: '二手房',
                link: 'http://esf.focus.cn',
            }, {
                name: '家居',
                link: 'http://home.focus.cn',
            }, {
                name: '娱乐',
                link: 'http://yule.sohu.com',
            }, {
                name: '视频',
                link: 'http://tv.sohu.com',
            }, {
                name: '电视剧',
                link: 'http://tv.sohu.com/drama',
            }, {
                name: '汽车',
                link: 'http://auto.sohu.com',
            }, {
                name: '买车',
                link: 'http://db.auto.sohu.com/home',
            }, {
                name: '新能源',
                link: 'http://auto.sohu.com/newenergy',
            }, {
                name: '时尚',
                link: 'http://fashion.sohu.com',
            }, {
                name: '旅游',
                link: 'http://travel.sohu.com',
            }, {
                name: '母婴',
                link: 'http://baobao.sohu.com',
            }, {
                name: '科技',
                link: 'http://it.sohu.com',
            }, {
                name: '教育',
                link: 'http://learning.sohu.com',
            }, {
                name: '健康',
                link: 'http://health.sohu.com',
            }, {
                name: '美食',
                link: 'http://chihe.sohu.com',
            }, {
                name: '文化',
                link: 'http://cul.sohu.com',
            }, {
                name: '历史',
                link: 'http://history.sohu.com',
            }, {
                name: '星座',
                link: 'http://astro.sohu.com',
            }, {
                name: '动漫',
                link: 'http://acg.sohu.com',
            }, {
                name: '游戏',
                link: 'http://game.sohu.com',
            }, {
                name: '政务',
                link: 'http://gov.sohu.com',
            }, {
                name: '公益',
                link: 'http://gongyi.sohu.com',
            }];
            return {
                'status': 200,
                'body': { data },
            }
        } else if (~url.indexOf('footer/config')) {
            const data: Array<{
                config: NavConfig[],
                spm: string,
            }> = [
                    {
                        spm: 'news',
                        config: [
                            {
                                'name': '新闻',
                                'link': '//news.sohu.com',
                            }, {
                                'name': '时政',
                                'link': '//www.sohu.com/c/8/1460',
                            }, {
                                'name': '国际',
                                'link': '//www.sohu.com/c/8/1461',
                            }, {
                                'name': '军事',
                                'link': '//mil.sohu.com/',
                            }, {
                                'name': '警法',
                                'link': 'http://police.news.sohu.com/',
                            }, {
                                'name': '专题',
                                'link': '//www.sohu.com/subject',
                            }, {
                                'name': '公益',
                                'link': '//gongyi.sohu.com/',
                            }, {
                                'name': '无人机',
                                'link': 'http://news.sohu.com/s2018/wrj/index.shtml',
                            }],
                    }, {
                        spm: 'sports',
                        config: [
                            {
                                'name': '体育',
                                'link': '//sports.sohu.com',
                            }, {
                                'name': 'NBA',
                                'link': '//sports.sohu.com/s/nba',
                            }, {
                                'name': 'CBA',
                                'link': '//sports.sohu.com/s/cba',
                            }, {
                                'name': '中超',
                                'link': '//sports.sohu.com/s/csl',
                            }, {
                                'name': '国足',
                                'link': '//sports.sohu.com/s/cnmenfootball',
                            }, {
                                'name': '英超',
                                'link': '//sports.sohu.com/s/premierleague',
                            }, {
                                'name': '西甲',
                                'link': '//sports.sohu.com/s/laliga',
                            }, {
                                'name': '意甲',
                                'link': '//sports.sohu.com/s/seriea',
                            }, {
                                'name': '欧冠',
                                'link': '//sports.sohu.com/s/uefacl',
                            }, {
                                'name': '综合',
                                'link': '//sports.sohu.com/s/integrated',
                            }],
                    }, {
                        spm: 'business',
                        config: [
                            {
                                'name': '财经',
                                'link': '//business.sohu.com',
                            }, {
                                'name': '宏观',
                                'link': '//business.sohu.com/category/macrography',
                            }, {
                                'name': '股票',
                                'link': '//q.stock.sohu.com/',
                            }, {
                                'name': '金融理财',
                                'link': '//business.sohu.com/category/financial',
                            }, {
                                'name': '房地产',
                                'link': '//business.sohu.com/category/realty',
                            }, {
                                'name': '搜狐酒业',
                                'link': '//business.sohu.com/category/wine',
                            }, {
                                'name': '科创板',
                                'link': '//business.sohu.com/category/kcb',
                            }],
                    }, {
                        spm: 'yule',
                        config: [
                            {
                                'name': '娱乐',
                                'link': '//yule.sohu.com',
                            }, {
                                'name': '明星',
                                'link': '//yule.sohu.com/1406',
                            }, {
                                'name': '电影',
                                'link': '//yule.sohu.com/1409',
                            }, {
                                'name': '电视剧',
                                'link': '//yule.sohu.com/1408',
                            }, {
                                'name': '综艺',
                                'link': '//yule.sohu.com/1410',
                            }, {
                                'name': '美图',
                                'link': '//yule.sohu.com/1407',
                            }],
                    }, {
                        spm: 'auto',
                        config: [
                            {
                                'name': '汽车',
                                'link': '//auto.sohu.com',
                            }, {
                                'name': '买车',
                                'link': '//db.auto.sohu.com/home/',
                            }, {
                                'name': '车贷',
                                'link': '//00.auto.sohu.com/d/index',
                            }, {
                                'name': '二手车',
                                'link': '//2sc.sohu.com',
                            }, {
                                'name': '新车',
                                'link': 'http://db.auto.sohu.com/newcar/',
                            }],
                    }, {
                        spm: 'focus',
                        config: [
                            {
                                'name': '房产',
                                'link': '//www.focus.cn',
                            }, {
                                'name': '新房',
                                'link': '//sports.sohu.com/s/nba',
                            }, {
                                'name': '二手房',
                                'link': '//esf.focus.cn/',
                            }, {
                                'name': '家居',
                                'link': '//home.focus.cn/',
                            }, {
                                'name': '租房',
                                'link': '//esf.focus.cn/house/rents',
                            }, {
                                'name': '地图找房',
                                'link': '//house.focus.cn/map/',
                            }, {
                                'name': '看房团',
                                'link': '//house.focus.cn/kanfangtuan/',
                            }, {
                                'name': '房产资讯',
                                'link': '//house.focus.cn/zixun/',
                            }],
                    }, {
                        spm: 'tech',
                        config: [
                            {
                                'name': '科技',
                                'link': '//it.sohu.com',
                            }, {
                                'name': '互联网',
                                'link': '//it.sohu.com/911',
                            }, {
                                'name': '通讯',
                                'link': '//it.sohu.com/934',
                            }, {
                                'name': '智能硬件',
                                'link': '//it.sohu.com/882',
                            }, {
                                'name': '生活服务',
                                'link': '//it.sohu.com/913',
                            }, {
                                'name': '创业投资',
                                'link': '//it.sohu.com/881',
                            }, {
                                'name': '科学',
                                'link': '//it.sohu.com/category/science/recommend',
                            }, {
                                'name': '5G',
                                'link': '//it.sohu.com/category/5G/record',
                            }, {
                                'name': '数码',
                                'link': '//it.sohu.com/936',
                            }],
                    }, {
                        spm: 'health',
                        config: [
                            {
                                'name': '健康',
                                'link': '//health.sohu.com',
                            }, {
                                'name': '生活大发现',
                                'link': '//health.sohu.com/category/discover',
                            }, {
                                'name': '食话食说',
                                'link': '//health.sohu.com/category/diet',
                            }, {
                                'name': '图说健康',
                                'link': '//health.sohu.com/category/picture',
                            }, {
                                'name': '健康白皮书',
                                'link': '//health.sohu.com/category/whitebook',
                            }, {
                                'name': '生命科学',
                                'link': '//health.sohu.com/category/cosmedical',
                            }, {
                                'name': '搜狐医药',
                                'link': '//health.sohu.com/category/medhelp',
                            }, {
                                'name': '健康主题日',
                                'link': '//health.sohu.com/category/themeday',
                            }, {
                                'name': '搜狐名医',
                                'link': '//health.sohu.com/category/doctor',
                            }],
                    }, {
                        spm: 'fashion',
                        config: [
                            {
                                'name': '时尚',
                                'link': '//fashion.sohu.com',
                            }, {
                                'name': '时装',
                                'link': '//fashion.sohu.com/1045',
                            }, {
                                'name': '奢品',
                                'link': '//fashion.sohu.com/1057',
                            }, {
                                'name': '美容',
                                'link': '//fashion.sohu.com/1051',
                            }, {
                                'name': '人物',
                                'link': '//fashion.sohu.com/1062',
                            }, {
                                'name': '荷尔蒙',
                                'link': '//fashion.sohu.com/1080',
                            }, {
                                'name': '男士',
                                'link': '//fashion.sohu.com/1068',
                            }, {
                                'name': '生活方式',
                                'link': '//fashion.sohu.com/1073',
                            }],
                    }, {
                        spm: 'learning',
                        config: [
                            {
                                'name': '教育',
                                'link': '//learning.sohu.com',
                            }, {
                                'name': '高考',
                                'link': '//learning.sohu.com/category/gaokao',
                            }, {
                                'name': '家长帮',
                                'link': '//learning.sohu.com/category/parent',
                            }, {
                                'name': '中小学',
                                'link': '//learning.sohu.com/category/zxx',
                            }, {
                                'name': '高校',
                                'link': '//learning.sohu.com/category/college',
                            }, {
                                'name': '留学',
                                'link': '//learning.sohu.com/category/studyabroad',
                            }, {
                                'name': '考试',
                                'link': '//learning.sohu.com/category/exam',
                            }],
                    }, {
                        spm: 'others',
                        config: [
                            {
                                'name': '其他',
                                'link': '',
                            }, {
                                'name': '军事',
                                'link': '//mil.sohu.com',
                            }, {
                                'name': '专题',
                                'link': '//www.sohu.com/subject',
                            }, {
                                'name': '文化',
                                'link': '//cul.sohu.com',
                            }, {
                                'name': '历史',
                                'link': '//history.sohu.com',
                            }, {
                                'name': '美食',
                                'link': '//chihe.sohu.com',
                            }, {
                                'name': '星座',
                                'link': '//astro.sohu.com',
                            }, {
                                'name': '旅游',
                                'link': '//travel.sohu.com',
                            }, {
                                'name': '母婴',
                                'link': '//baobao.sohu.com',
                            }, {
                                'name': '动漫',
                                'link': '//acg.sohu.com',
                            }, {
                                'name': '游戏',
                                'link': '//game.sohu.com',
                            }]
                    }
                ];
            return {
                'status': 200,
                'body': { data },
            }
        }
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/utils/_httpInject.ts